export enum TenantTypeEnum {
    TENANT = 'tenant',
    WHITELABEL = 'wl',
}
